import React, { useEffect, useRef } from "react";

function getInitials(name) {
    const words = name?.trim()?.split(/\s+/) || []
    if (!words.length) {
        return ""
    }
    else if (words.length > 1) {
        return (words[0][0] + words[1][0]).toUpperCase();
    }

    return words[0][0].toUpperCase() + words[0][1].toUpperCase();
}

export default function EverbaryChatMessages({ messages, userRole ,userId }) {
    const el = useRef(null);
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (el.current) {
                el.current.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }, 100);
    
        return () => clearTimeout(timeout); 
    }, [messages]);
    return (
        <div className="messages-container customScroll">
        {messages.map((msg, index) => {
            const isSentByMe = msg.senderId === userId; 

            return (
                <div key={index} className={`message-wrapper ${isSentByMe ? "sent" : "received"}`}>
                    
                
                    {!isSentByMe && (
                        <div className="avatar-container">
                            {msg?.profilePic?.url ? (
                                <img src={msg.profilePic.url} alt={getInitials(msg?.senderName)} className="avatar" />
                            ) : (
                                <div className="avatar">{getInitials(msg?.senderName)}</div>
                            )}
                            <div className="tooltip left">{msg?.senderName}</div>
                        </div>
                    )}

                    
                    <div className={`message ${isSentByMe ? "sent-message" : "received-message"}`}>
                        <div className="chatMessages" dangerouslySetInnerHTML={{ __html: msg.message }} />
                    </div>

                    
                    {isSentByMe && (
                        <div className="avatar-container">
                            {msg?.profilePic?.url ? (
                                <img src={msg.profilePic.url} alt={getInitials(msg?.senderName)} className="avatar" />
                            ) : (
                                <div className="avatar">{getInitials(msg?.senderName)}</div>
                            )}
                            <div className="tooltip right">{msg?.senderName}</div>
                        </div>
                    )}
                </div>
            );
        })}
        <div ref={el} />
    </div>
    );
}